/* __next_internal_client_entry_do_not_use__ SDUIOnClickHandler auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { shouldUseAnchorForLink } from "@faire/web--source/ui/lib";
import { Anchor, Link } from "@faire/web--source/ui/LinkAnchor";
import React, { useMemo } from "react";
import { extractLinkFromActions } from "@faire/retailer/components/SDUI/__internal__/ActionHandler/extractLinkFromActions";
import { useSDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/ActionHandler/useSDUIOnClickHandler";
import { ComponentLoggingEventParams } from "@faire/retailer/components/SDUI/__internal__/types";
import { useCategoryNavigationPrefetch, isCategoryUrl } from "@faire/retailer/lib/useCategoryNavigationPrefetch";
export var SDUIOnClickHandler = function(param) {
    var children = param.children, className = param.className, componentStyle = param.componentStyle, onClickActions = param.onClickActions, loggingData = param.loggingData, _param_logSDUIClickEvent = param.logSDUIClickEvent, logSDUIClickEvent = _param_logSDUIClickEvent === void 0 ? true : _param_logSDUIClickEvent, _param_logLegacyClickEvent = param.logLegacyClickEvent, logLegacyClickEvent = _param_logLegacyClickEvent === void 0 ? false : _param_logLegacyClickEvent;
    var _useMemo = useMemo(function() {
        return extractLinkFromActions(onClickActions !== null && onClickActions !== void 0 ? onClickActions : []);
    }, [
        onClickActions
    ]), link = _useMemo.link, nonNavigationActions = _useMemo.nonNavigationActions;
    var _useCategoryNavigationPrefetch = useCategoryNavigationPrefetch(), prefetchOnMouseEnter = _useCategoryNavigationPrefetch.prefetchOnMouseEnter, prefetchOnTouchStart = _useCategoryNavigationPrefetch.prefetchOnTouchStart, clearPrefetchTimeoutOnBlur = _useCategoryNavigationPrefetch.clearPrefetchTimeoutOnBlur;
    var onClickHandler = useSDUIOnClickHandler(nonNavigationActions, loggingData !== null && loggingData !== void 0 ? loggingData : ComponentLoggingEventParams.build({}), {
        logSDUIClickEvent: logSDUIClickEvent,
        logLegacyClickEvent: logLegacyClickEvent
    });
    if (link !== undefined) {
        if (shouldUseAnchorForLink(link)) {
            return /*#__PURE__*/ _jsx(Anchor, {
                className: className,
                style: componentStyle,
                href: link,
                onClick: onClickHandler,
                children: children
            });
        } else {
            var shouldEnableNextPrefetch = isCategoryUrl(link);
            return /*#__PURE__*/ _jsx(Link, {
                className: className,
                style: componentStyle,
                to: link,
                onClick: onClickHandler,
                onMouseEnter: shouldEnableNextPrefetch ? function() {
                    return prefetchOnMouseEnter(link);
                } : undefined,
                onTouchStart: shouldEnableNextPrefetch ? function() {
                    return prefetchOnTouchStart(link);
                } : undefined,
                onMouseLeave: shouldEnableNextPrefetch ? clearPrefetchTimeoutOnBlur : undefined,
                children: children
            });
        }
    }
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        onClick: onClickHandler,
        style: componentStyle,
        children: children
    });
};
